import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const StepperK = ({ activeStep, steps }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>
              <div
                style={{
                  color: '#131F32',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                {label}
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperK;
